import React, { useEffect, useState } from "react";
import { errorNotify } from "../../services/toast.notification";
import { getLabFeedback} from '../../api/api';
import { useAppDispatch, useAppSelector } from '../../redux/store/storehooks';
import Spinner from "../../components/_common/Spinner";
import './style.css'
import { UpdateLabFeedback } from "../../redux/reducers/LabFeedbackSlice";
import Table, { ColumnsType } from "antd/lib/table";
import './style.css'

export interface InputProps {
  url: any
}

const Feedback = ({url}:InputProps) => {

    const machine_columns: ColumnsType<any> = [
        {title: 'دستگاه',dataIndex: 'Name',key: 'Name'},
        {title: 'اولین استفاده',dataIndex: 'FirstUseDate',key: 'FirstUseDate'},
        {title: 'آخرین استفاده',dataIndex: 'LastUseDate',key: 'LastUseDate'},
        {title: 'کاربر',dataIndex: 'LastUser',key: 'LastUser'},
        {title: 'انتقال جواب',dataIndex: 'UsageCount',key: 'UsageCount'},  
        {title: 'QC',dataIndex: 'QC',key: 'QC'},  
    ];

    const system_columns: ColumnsType<any> = [
        {title: 'بخش',dataIndex: 'Name',key: 'Name'},
        {title: 'آخرین استفاده',dataIndex: 'LastUseDate',key: 'LastUseDate'},
        {title: 'کاربر/توضیحات',dataIndex: 'LastUser',key: 'LastUser'},
        
    ];


  const myStore = useAppSelector((state) => state)
  const dispatch = useAppDispatch();
  const [isLoading,setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(1);

  const handleTabClick = (id:any) => {
    setActiveTab(id);
  };

  const _getLabFeedback = (url:string) => {
    getLabFeedback(url)
    .then((result:any) => {
      let jsonResult = JSON.parse(result.data.json);
      dispatch(UpdateLabFeedback({ MachineUsage:jsonResult.MachineUsage,SystemUsage:jsonResult.SystemUsage}))
      setIsLoading(false);
      //console.log('backup info is: '+ result.data.json);
    })
    .catch((error) => {
      console.log(error);
      errorNotify(error.response.data.errorMessage,undefined,5000)
    }) 
    
    
}

  useEffect(() => {
    _getLabFeedback(url);
  }, [])

  return(
    <div className="tab-content-padding">
     { 
        isLoading === false  && (
        <>
            <ul className="inner-tabs">
            <li className={activeTab === 1 ? 'financialRepTabActive' : 'financialRepTab'} onClick={() => handleTabClick(1) }> اطلاعات مربوط به استفاده از دستگاه‌های آزمایشگاهی </li>
                <li className={activeTab === 2 ? 'financialRepTabActive' : 'financialRepTab'} onClick={() => handleTabClick(2) }>اطلاعات مربوط به استفاده از بخش‌های مختلف سیستم </li>
            
            </ul>

            <div className="inner-tabs_content">
                { 
                activeTab === 1 &&
                <div className="tab_panel">
                        <Table scroll={{ x: 1500 }}
                                dataSource={myStore.labFeedbacks.MachineUsage} columns={machine_columns}
                                />              
                    </div> 
                }
                { 
                    activeTab === 2 && 
                    <div className="tab_panel">
                        <Table scroll={{ x: 1500 }}
                                dataSource={myStore.labFeedbacks.SystemUsage} columns={system_columns}
                                />           
                    </div> 
                }      
        </div>
        </> 
        )
    }
    {
      isLoading === true  && (
      <Spinner />
    )
    }
    </div>  
      
    )
}
export default Feedback;
